<div class="narrow-container p-32:b p-48:t md:p-72:b lg:p-96:b">
    <div class="m-32:b md:m-48:b">
        <h1 class="align:c m-0:b">Unsere Versicherungen</h1>
    </div>
    <div class="grid-container -center-content -no-horizontal-gutters">
        @for (card of cards; track card.title) {
            <a
                class="prod-cat-card"
                [ngClass]="card.icon"
                [routerLink]="card.route"
            >
                <span [innerHTML]="card.title"></span>
            </a>
        }
    </div>
</div>
